// extracted by mini-css-extract-plugin
module.exports = {"summarycard":"summarycard-module__summarycard___2Fezc"};